module.exports = __webpack_public_path__ + "img/claim-icon.0655a1bc.svg";